// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style_containerStyle__n9jTC {
  position: fixed !important;
  top: 6em !important;
  z-index: 3901;
}

.style_modalContainer__-UE-b {
  width: 70vw;
  height: auto;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 16px;
}

.style_modalContent__9OefZ {
  width: 100%;
  overflow: auto;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  height: 400px;
  overflow: auto;
  padding: 0;
  scrollbar-color: #e3e3e3 transparent;
  scrollbar-width: 10px;
}

.style_modalContent__9OefZ::-webkit-scrollbar {
  background: transparent;
  width: 10px;
}

.style_modalContent__9OefZ::-webkit-scrollbar-thumb {
  background-color: #e3e3e3;
  border-radius: 100px;
  height: 10px;
}

.style_CropControls__-Br1v {
  margin-bottom: 10px;
  width: 30%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-left: 10px;
}

.style_CropControls__-Br1v > div {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  margin-bottom: 20px;
}

.style_CropControls__-Br1v > div label, .style_toggleText__B1uBn {
  width: 100px;
  text-align: right;
  color: #333;
}

.style_CropControls__-Br1v .style_text__CAF9a {
  text-align: right;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #333;
  width: 100%;
}

.style_CropControls__-Br1v > * {
  margin-bottom: 3px;
}

.style_cropContainer__dvlZ- {
  width: 70%;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.style_cropContainer__dvlZ- > div {
  border: 1px solid #fff;
}

.style_CropControls__-Br1v > div:nth-child(2) {
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.style_cropContainer__dvlZ- img {
  width: 100%;
  height: auto;
}

.style_modalContent__9OefZ img {
  height: auto;
  margin: 0 auto;
}

.style_button__3u3rQ {
  background-color: #d8000d;
  color: #fff;
  border-radius: 8px;
  padding: 8px 12px;
}

.style_inputError__h01Jw {
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #ff9315;
  margin-top: 8px;
  margin-right: 20px;
}

.style_lds_ring__eGUnj {
  display: inline-block;
  position: relative;
  width: 20px;
  height: 20px;
  margin-bottom: 10px;
  margin-right: 20px;
}

.style_lds_ring__eGUnj div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 14px;
  height: 14px;
  margin: 8px;
  border: 1px solid #d8000d;
  border-radius: 50%;
  animation: style_lds_ring__eGUnj 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: #d8000d transparent transparent transparent;
}

.style_lds_ring__eGUnj div:nth-child(1) {
  animation-delay: -0.45s;
}

.style_lds_ring__eGUnj div:nth-child(2) {
  animation-delay: -0.3s;
}

.style_lds_ring__eGUnj div:nth-child(3) {
  animation-delay: -0.15s;
}

@keyframes style_lds_ring__eGUnj {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
@media only screen and (max-width: 926px) {
  .style_modalContent__9OefZ {
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    height: auto;
  }
  .style_cropContainer__dvlZ-, .style_CropControls__-Br1v {
    width: 100%;
    box-sizing: border-box;
    padding: 0 10px;
  }
}
@media only screen and (max-width: 800px) {
  .style_containerStyle__n9jTC {
    position: fixed !important;
    top: 6em !important;
    left: 0;
  }
  .style_noBackground__g3E0P {
    background: unset !important;
  }
  .style_modalContainer__-UE-b {
    width: 100vw;
  }
}`, "",{"version":3,"sources":["webpack://./../src/renderer/components/FileUpload/style.module.scss"],"names":[],"mappings":"AAUA;EACE,0BAAA;EACA,mBAAA;EACA,aAAA;AATF;;AAYA;EACE,WAAA;EACA,YAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,uBAAA;EAGA,aAAA;AAXF;;AAcA;EACE,WAAA;EACA,cAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,uBAAA;EACA,aAAA;EACA,cAAA;EAEA,UAAA;EACA,oCAAA;EACA,qBAAA;AAZF;;AAeA;EAEE,uBAAA;EACA,WAAA;AAbF;;AAgBA;EACE,yBAAA;EACA,oBAAA;EACA,YAAA;AAbF;;AAeA;EACE,mBAAA;EACA,UAAA;EACA,sBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AAZF;;AAcA;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,mBAAA;EACA,WAAA;EACA,mBAAA;AAXF;;AAaA;EACE,YAAA;EACA,iBAAA;EACA,WAAA;AAVF;;AAYA;EACE,iBAAA;EACE,aAAA;EAEA,8BAAA;EACA,mBAAA;EAEA,WAAA;EACJ,WAAA;AAXA;;AAaA;EACE,kBAAA;AAVF;;AAYA;EACI,UAAA;EACF,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;AATF;;AAYA;EACE,sBAAA;AATF;;AAWA;EACE,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;AARF;;AAUA;EACE,WAAA;EACC,YAAA;AAPH;;AAUA;EAIE,YAAA;EACA,cAAA;AAVF;;AAYA;EACE,yBAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;AATF;;AAWA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;AARF;;AAaA;EACE,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;AAVF;;AAaA;EACE,sBAAA;EACA,cAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,2EAAA;EACA,yDAAA;AAVF;;AAaA;EACE,uBAAA;AAVF;;AAaA;EACE,sBAAA;AAVF;;AAaA;EACE,uBAAA;AAVF;;AAaA;EACE;IACE,uBAAA;EAVF;EAaA;IACE,yBAAA;EAXF;AACF;AAeA;EACE;IAEE,sBAAA;IACA,2BAAA;IACA,mBAAA;IACA,YAAA;EAdF;EAiBA;IACE,WAAA;IACA,sBAAA;IACA,eAAA;EAfF;AACF;AAkBA;EACA;IACE,0BAAA;IACA,mBAAA;IACA,OAAA;EAhBA;EAkBF;IACE,4BAAA;EAhBA;EAkBF;IACE,YAAA;EAhBA;AACF","sourcesContent":["// label {\n//     display: inline-block;\n//     background-color: indigo;\n//     color: white;\n//     padding: 0.5rem;\n//     font-family: sans-serif;\n//     border-radius: 0.3rem;\n//     cursor: pointer;\n//     margin-top: 1rem;\n// }\n.containerStyle{\n  position:fixed !important;\n  top:6em !important;\n  z-index:3901;\n\n}\n.modalContainer{\n  width:70vw;\n  height:auto;\n  box-sizing: border-box;\n  display:flex;\n  flex-direction:row;\n  justify-content:flex-start;\n  align-items:flex-start;\n\n  // font-family: sans-serif;\n  padding: 16px;\n\n}\n.modalContent{\n  width:100%;\n  overflow:auto;\n  box-sizing: border-box;\n  display:flex;\n  flex-direction:row;\n  justify-content:flex-start;\n  align-items:flex-start;\n  height:400px;\n  overflow:auto;\n  // font-family: sans-serif;\n  padding:0;\n  scrollbar-color: #e3e3e3 transparent;\n  scrollbar-width: 10px;\n}\n\n.modalContent::-webkit-scrollbar {\n  // display: none !important;\n  background: transparent;\n  width: 10px;\n}\n\n.modalContent::-webkit-scrollbar-thumb {\n  background-color: #e3e3e3;\n  border-radius: 100px;\n  height: 10px;\n}\n.CropControls {\n  margin-bottom: 10px;\n  width:30%;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding-left:10px;\n}\n.CropControls>div{\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  align-items: center;\n  width:100%;\n  margin-bottom:20px;\n}\n.CropControls>div label, .toggleText{\n  width:100px;\n  text-align:right;\n  color: #333;\n}\n.CropControls .text{\n  text-align: right;\n    display: flex;\n    \n    justify-content: space-between;\n    align-items:center;\n    // margin: 0 auto;\n    color: #333;\nwidth:100%;\n}\n.CropControls > * {\n  margin-bottom: 3px;\n}\n.cropContainer{\n    width: 70%;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n\n}\n.cropContainer>div{\n  border: 1px solid #fff;\n}\n.CropControls>div:nth-child(2){\n  box-sizing: border-box;\n  display:flex;\n  flex-direction:row;\n  justify-content:center;\n  align-items:center;\n}\n.cropContainer img{\n  width:100%;\n   height:auto;\n}\n\n.modalContent img {\n  // max-width: 100%;\n  // max-height:100%;\n  // height:400px;\n  height:auto;\n  margin:0 auto;\n}\n.button{\n  background-color: #d8000d;\n  color:#fff;\n  border-radius:8px;\n  padding: 8px 12px;\n}\n.inputError {\n  font-style: normal;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  color: #ff9315;\n  margin-top: 8px;\n  margin-right: 20px;\n  // justify-self: flex-start;\n}\n//------------------------loader style\n\n.lds_ring {\n  display: inline-block;\n  position: relative;\n  width: 20px;\n  height: 20px;\n  margin-bottom: 10px;\n  margin-right: 20px;\n}\n\n.lds_ring div {\n  box-sizing: border-box;\n  display: block;\n  position: absolute;\n  width: 14px;\n  height: 14px;\n  margin: 8px;\n  border: 1px solid #d8000d;\n  border-radius: 50%;\n  animation: lds_ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;\n  border-color: #d8000d transparent transparent transparent;\n}\n\n.lds_ring div:nth-child(1) {\n  animation-delay: -0.45s;\n}\n\n.lds_ring div:nth-child(2) {\n  animation-delay: -0.3s;\n}\n\n.lds_ring div:nth-child(3) {\n  animation-delay: -0.15s;\n}\n\n@keyframes lds_ring {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n\n@media only screen and (max-width: 926px) {\n  .modalContent{\n\n    flex-direction:column;\n    justify-content:flex-start;\n    align-items:center;\n    height:auto;\n  }\n  \n  .cropContainer, .CropControls{\n    width:100%;\n    box-sizing: border-box;\n    padding:0 10px;\n  }\n}\n\n@media only screen and (max-width: 800px) {\n.containerStyle{\n  position:fixed !important;\n  top:6em !important;\n  left:0\n}\n.noBackground{\n  background:unset !important;\n}\n.modalContainer{\n  width:100vw;\n}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"containerStyle": `style_containerStyle__n9jTC`,
	"modalContainer": `style_modalContainer__-UE-b`,
	"modalContent": `style_modalContent__9OefZ`,
	"CropControls": `style_CropControls__-Br1v`,
	"toggleText": `style_toggleText__B1uBn`,
	"text": `style_text__CAF9a`,
	"cropContainer": `style_cropContainer__dvlZ-`,
	"button": `style_button__3u3rQ`,
	"inputError": `style_inputError__h01Jw`,
	"lds_ring": `style_lds_ring__eGUnj`,
	"noBackground": `style_noBackground__g3E0P`
};
export default ___CSS_LOADER_EXPORT___;
